import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AppProvider } from "@/context/AppContext";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import Track from "@/pages/Track";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import Campaigns from "@/pages/Campaigns";
import RafflePublic from "@/pages/RafflePublic";
import KuryeDelivery from "@/pages/KuryeDelivery";
import InstallPrompt from "@/components/InstallPrompt";

function AppRouter() {
  const location = useLocation();

  // Detect OAuth callback synchronously (before any protected route runs)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/kampanyalar" element={<Campaigns />} />
      <Route path="/cekilis/:slug" element={<RafflePublic />} />
      <Route path="/track" element={<Track />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/kurye/t/:token" element={<KuryeDelivery />} />
      {/* Hidden admin URL — not linked from public UI */}
      <Route path="/panel-ikz-lefke" element={<Admin />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppProvider>
          <AppRouter />
          <InstallPrompt />
          <Toaster position="bottom-center" richColors duration={1500} toastOptions={{ className: "ikz-toast" }} />
        </AppProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
